import { useEffect } from "react"
import { UseFlyToMap } from "./interface"
import { useIndoorMap } from "providers/venue/modules/indoormap/hooks/useIndoorMap"
import { useVenue } from "providers/venue"
import { isNil } from "lodash"

/**
 * @deprecated Use `flyTo` directly from `useIndoorMap` instead.
 * Example: `const { flyTo } = useIndoorMap();`
 *
 * This hook was a utility to call `indoorMap.flyTo`.
 */
export const useFlyToMap: UseFlyToMap = (options) => {
  const { dataLoaded } = useVenue()
  const { indoorRef, mapLoaded } = useIndoorMap()
  const mapReady = indoorRef?.current && mapLoaded && dataLoaded

  useEffect(() => {
    if (!mapReady || isNil(options)) return

    const { zoom, bearing, center, pitch } = options || {}

    const indoorMap = indoorRef.current

    indoorMap.flyTo(center, {
      zoom,
      bearing,
      pitch,
    })
  }, [mapReady, options, indoorRef])
}
